
export const ROUTES = {
    ROOT: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    APP: '/app',
    APP_ONBOARDING: '/app/onboarding',
    APP_PROMPTS: '/app/prompts',
    APP_PROMPT_DETAIL: '/app/prompts/:id',
    APP_LEADERS: '/app/leaders',
    APP_LEADER_DETAIL: '/app/leaders/:leaderId',
    APP_ASSESSMENT: '/app/assessment',
    APP_PERSONALITY_DASHBOARD: '/app/personality-dashboard',
    APP_PROFILE: '/app/profile',
    APP_FAVOURITES: '/app/favourites',
    APP_SEEN: '/app/seen',
    APP_UNSEEN: '/app/unseen',
    APP_LIBRARY: '/app/library',
    ASSESSMENT: '/assessment',
    TERMS_AND_CONDTION: '/terms-and-conditions',
    PRIVACY_POLICY: '/privacy-policy',
    SUBSCRIPTION_PLANS: '/subscription-plans',
    CHECKOUT: '/checkout',
    ABOUT: "/about",
    REPORT: "/report",
    FORGET: "/forget",
    FORGOT_PASSWORD: "/forgot-password",
    FEEDBACK: "/feedback",
    MISSION: "/mission",
    SUPPORT: "/support",
    FAQ: "/FAQ",
    PROFILE: "/Profile"
}

export const SOURCE_TYPE = {
    USER: 'Users',
};

export const TOUR_IDS = {
    PROMPTS: "prompts",
    SIDEBAR: "sidebar",
    ASSESSMENT: "assessment",
    PERSONALITY_DASHBOARD: "personality-dashboard",
    PROMPT_LIST: "prompt-list",
};

export const TOUR_LABELS = {
    [TOUR_IDS.PROMPTS]: "Explore Prompts",
    [TOUR_IDS.SIDEBAR]: "Navigation Sidebar",
    [TOUR_IDS.ASSESSMENT]: "Assessment",
    [TOUR_IDS.PERSONALITY_DASHBOARD]: "Personality Dashboard",
    [TOUR_IDS.PROMPT_LIST]: "Prompt Collections",
};
